import { parseEther } from 'ethers/lib/utils'

export default function isAmountValid(amount, balanceWei) {
    return !Number.isNaN(Number(amount)) && amount > 0 && parseEther(amount).lte(balanceWei)
}
